/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-25 16:14:45 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-05-16 15:18:16
 */


import { faInbox } from "@fortawesome/fontawesome-free-solid"
import { Paper, TextField } from "material-ui"
import PropTypes from "prop-types"
import React from "react"

import core from "../../core"
import model from "../../../model"
import calendar from "../../calendar"
import { Button } from "material-ui"
import { useState } from "react"
import { updateCounsellorInfo } from "../../../service/api"
import { bindActionCreators } from "redux"
import * as actions from "../../messages/actions"
import {onSearchSuccess} from "../actions"
import { connect } from "react-redux"
import { Switch } from "material-ui"
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/fontawesome-free-solid'
import { useEffect } from "react"
import { failedMessage } from "service/constants"

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    ...actions,
    updateCounsellors: onSearchSuccess
  }, dispatch)
)

const mapStateToProps = (state) => ({
  calendars: calendar.selectors.getCalendars(state)
})

const ListItem = ({calendar, onClick, showMessage, calendars, maxDate, minDate, updateCounsellors}) => {
  const {share: calShare, fee: calFee, external: calExternal, GSTEnabled: calGST, acuityID} = calendar

  const [share, setShare] = useState(calShare)
  const [fee, setFee] = useState(calFee)
  const [external, setExternal] = useState(calExternal)
  const [loading, setLoading] = useState(false)

  const saveInfo = async (e, GSTEnabled = null) => {
    e.stopPropagation()

    const updatedInfo = {
      share,
      fee,
      external,
      GSTEnabled
    }
    
    const requestParams = {
      maxDate,
      minDate
    }
    
    try { 
      setLoading(true)
      const updatedCounsellor = await updateCounsellorInfo(updatedInfo, requestParams)
  
      const newCalendars = [...calendars]
      const calendarIndex = calendars.findIndex(cal => cal.acuityID === acuityID)
      
      newCalendars.splice(calendarIndex, 1, {...updatedCounsellor})
      
      updateCounsellors([...newCalendars])
    } catch(e) {
      showMessage(failedMessage)
    } finally {
      setLoading(false)
    }
  }

  const onChange = (value, setState) => {
    setState(+value)
  }

  const elemetClick = e => {
    e.stopPropagation()
  } 

  const disabled = loading || (share === calShare && fee === calFee && external === calExternal)

  return (
    <Paper elevation={4} className="small-margin stretch counsellor">
      <article className="calendar__list-item" onClick={onClick}>
        <div className="calendar__list-item" style={{flex: 1}}>
          <h3>{calendar.name}</h3>
        </div>
        <div className="calendar__list-item" style={{flex: 0.5}}>
          <span>Share %</span>
          <TextField 
            type="number"
            onClick={elemetClick}  
            className="counsellor-input" 
            value={share}
            onChange={(e) => onChange(e.target.value, setShare)}
          />
        </div>
        <div className="calendar__list-item" style={{flex: 0.5}}>
          <span>External $</span>
          <TextField 
            type="number"
            onClick={elemetClick} 
            className="counsellor-input" 
            value={external}
            onChange={(e) => onChange(e.target.value, setExternal)}
          />
        </div>
        <div className="calendar__list-item" style={{flex: 0.8}}>
          <span>Service fee %</span>
          <TextField 
            type="number"
            onClick={elemetClick} 
            className="counsellor-input" 
            value={fee}
            onChange={(e) => onChange(e.target.value, setFee)}
          />
        </div>
        <div className="calendar__list-item" style={{flex: 0.5}}>
          <span>GST</span>
          <Switch 
            onClick={elemetClick}
            color="warning"
            color="primary"
            onChange={(e) => saveInfo(e, e.target.checked)}
            checked={calGST}
            disabled={loading}
          />
        </div>
        <Button 
          disabled={disabled}
          color="secondary" 
          variant="raised" 
          className="counsellor-button"
          onClick={saveInfo}
        >
          {
            loading 
              ? <FontAwesomeIcon icon={faSpinner} spin />
              : "Save"
          }
        </Button>
      </article>
    </Paper>
    )
  }

ListItem.propTypes = {
  calendar: model.CalendarShape,
  onChange: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(ListItem)